module.exports = __webpack_public_path__ + "static/media/cups.ed6802f6.JPG";